import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/37.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Nie pomagasz"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p64
            }}
            content={
                <div>
                    <ul>
                        <li>Przekorny los, panie Stefanie – wyzłośliwiasz się. To doskonała okazja, żeby odgryźć się gęsiarzowi za wczorajsze upokorzenia.</li>
                        <li>Nie gniewaj się za wczoraj, to były tylko takie żarty… – mamrocze Stefan.</li>
                        <li>Znacie się? – pyta cię Emil.                        </li>
                        <li>Koryto! Chwała Bogu, koryto! – krzyczy Stefan, pokazując na wodę. Między wysepkami widać łódkę. Po chwili dostrzegacie w niej człowieka z włosami białymi jak gęsi puch. To musi być on, stary Tornau!</li>
                    </ul>
                </div>
            }
        />

    );
}